import { makeStyles } from '@mui/styles';

export const usePricingRulesProductsStyle = makeStyles(() => ({
  radioButton: {
    width: 100,
    minWidth: 100,
  },
}));
